module.exports = __webpack_public_path__ + "img/symbol_5.76de4740.png";